import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import CaixaLivre1 from '../imagens/LancCaixaLivre/CaixaLivre1.png';
import CaixaLivre2 from '../imagens/LancCaixaLivre/CaixaLivre2.png';
import CaixaLivre3 from '../imagens/LancCaixaLivre/CaixaLivre3.png';

export default class CaixaLivre extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar a Venda Balcão"
                visible={isOpen}
                className="modal"
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
                bodyStyle={{
                    maxHeight: "80vh",
                    overflowY: "auto"
                }}
            >
                <Row>

                    <h3 style={{ fontSize: 26, marginTop: 18 }}>Funcionalidades da Venda Balcão</h3>

                    <p style={{ fontSize: 18, marginTop: 18 }}>
                        Dentro da tela do caixa existem diversas funcionalidades para o uso do gestor. Neste guia vamos explorar cada uma delas.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img src={CaixaLivre1} alt="tela do caixa" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
                    </div>

                    <p style={{ fontSize: 18, marginTop: 18 }}>Das opções mostradas acima nós temos:</p>
                    <ol>
                        <li>Iniciar uma nova venda;</li>
                        <li>Abre a tela de ficha financeira onde você pode buscar as movimentações financeiras dos clientes;</li>
                        <li>Abre a tela de vendas onde você pode consultar todas as vendas feitas;</li>
                        <li>Abre a tela de cadastro de clientes, caso você precise cadastrar um novo cliente;</li>
                        <li>Abre a tela do extrato do caixa;</li>
                        <li>Abre a tela onde exibe os condicionais por cliente;</li>
                        <li>Dados que devem ser preenchidos para adicionar um produto na venda;</li>
                        <li>Informações dos itens adicionados a venda atual.</li>
                    </ol>

                    <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

                    <h3 style={{ fontSize: 26, marginTop: 34 }}>Como fazer vendas</h3>

                    <p style={{ fontSize: 18, marginTop: 18 }}>
                        Para fazer uma venda, basta preencher os campos como na imagem abaixo e clicar em "gravar Produto" para adicionar um produto a lista da venda.
                        Depois que você tiver adicionado pelo menos um item a lista de produtos da venda, o botão "finalizar venda" irá aparecer.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img src={CaixaLivre2} alt="tela do caixa" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
                    </div>

                    <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

                    <p style={{ fontSize: 18, marginTop: 34 }}>
                        Na janela que foi aberta para efetuar a venda basta adicionar os dados da venda e clicar em "salvar venda", mas preste atenção a alguns detalhes:
                    </p>
                    <ol style={{ fontSize: 18, marginTop: 18 }}>
                        <li>
                            Escolher se é uma venda ou condicional no campo "Tipo". Condicional seria diferente de venda no sentido que o item sai do estoque
                            mas não foi vendido para o cliente, apenas enviado para o cliente poder avaliar se irá finalizar a compra. Um exemplo disso são lojas de roupas
                            que mandam roupas para clientes experimentarem.
                        </li>
                        <li>
                            Após escolher o "Tipo de documento" e "Condição de pagamento" você precisa clicar no botão de "Calcular parcelas" (botão marcado em vermelho na
                            imagem abaixo), assim o caixa poderá Calcular as parcelas de pagamento da venda.
                        </li>
                        <li>
                            Caso seja necessário emitir NFe da venda, não esquecer de marcar a opção "Emite NFe".
                        </li>
                        <li>
                            Você pode também alterar manualmente as parcelas ou excluir e recalcular as parcelas do pagamento utilizando os outros botões.
                        </li>
                    </ol>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img src={CaixaLivre3} alt="tela do caixa" style={{ marginTop: 15, maxWidth: "100%", height: "auto", objectFit: "contain" }} />
                    </div>

                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancCaixaLivre.js